module.exports = __webpack_public_path__ + "img/芡实.662bc06e.jpg";